module.exports = __webpack_public_path__ + "static/media/thumb.273fddaa.jpg";